export const ACTIVITY_TYPE_LABELS: Record<string, string> = {
  TRAINING: 'Capacitación',
  INSPECTION: 'Reto',
  INSPECTION_ITEM: 'Ítem de Reto',
  ORG_INFO: 'Información',
  ORG_CREATED: 'Creado',
};

export const getActivityTypeLabel = (type: string): string =>
  ACTIVITY_TYPE_LABELS[type] ?? type;
